import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { router, routesPath } from '../../router'
import { selectors } from '../../redux'

export const useHome = () => {
  const { t } = useTranslation()
  const user = useSelector(selectors.auth.user)

  return {
    background: `${import.meta.env.BASE_URL}images/onboarding/login.jpg`,
    header: {
      title: t('declaration.home.card.title', { name: `${user?.firstName} ${user?.lastName}` }),
    },
    content: {
      title: t('declaration.home.content.title'),
      button: {
        text: t('declaration.home.content.button.text'),
        href: router(routesPath.userDeclarations),
      },
    },
  }
}
